/**
 * Workflow Session Service
 * Workflow session management service API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@generator-strategies/auth-strategy';
import { LanguageStrategy } from '@generator-strategies/language-strategy';
import { TenantStrategy } from '@generator-strategies/tenant-strategy';

// @ts-ignore
import { CreateWorkflowConfigurationRequestDto } from '../model/createWorkflowConfigurationRequestDto';
// @ts-ignore
import { UpdateWorkflowConfigurationRequestDto } from '../model/updateWorkflowConfigurationRequestDto';
// @ts-ignore
import { WorkflowConfigurationsControllerCreate200Response } from '../model/workflowConfigurationsControllerCreate200Response';
// @ts-ignore
import { WorkflowConfigurationsControllerList200Response } from '../model/workflowConfigurationsControllerList200Response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class WorkflowConfigurationsService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy,
    @Optional() private readonly languageStrategy: LanguageStrategy,
    @Optional() private readonly tenantStrategy: TenantStrategy,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * Create a workflow configuration
   * @param createWorkflowConfigurationRequestDto
   */
  public async workflowConfigurationsControllerCreate(createWorkflowConfigurationRequestDto: CreateWorkflowConfigurationRequestDto, ): Promise<WorkflowConfigurationsControllerCreate200Response> {
    if (createWorkflowConfigurationRequestDto === null || createWorkflowConfigurationRequestDto === undefined) {
      throw new Error('Required parameter createWorkflowConfigurationRequestDto was null or undefined when calling workflowConfigurationsControllerCreate.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-workflow-session/workflow-configurations`,
        data: createWorkflowConfigurationRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Get workflow configuration by ID
   * @param id Workflow configuration identifier
   */
  public async workflowConfigurationsControllerGetById(id: string, ): Promise<WorkflowConfigurationsControllerCreate200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling workflowConfigurationsControllerGetById.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/forthbridge-workflow-session/workflow-configurations/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * List workflow configurations
   * @param workflowKey Filter by workflow key
   * @param limit Number of items to return
   * @param offset Number of items to skip
   */
  public async workflowConfigurationsControllerList(workflowKey?: string, limit?: number, offset?: number, ): Promise<WorkflowConfigurationsControllerList200Response> {

    const localVarQueryParameters = new URLSearchParams();
    if (workflowKey !== undefined && workflowKey !== null) {
      localVarQueryParameters.append('workflowKey', String(workflowKey));
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters.append('limit', String(limit));
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters.append('offset', String(offset));
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-workflow-session/workflow-configurations?${queryString}` : `${this.configuration.basePath}/api/forthbridge-workflow-session/workflow-configurations`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Update workflow configuration
   * @param id Workflow configuration identifier
   * @param updateWorkflowConfigurationRequestDto
   */
  public async workflowConfigurationsControllerUpdate(id: string, updateWorkflowConfigurationRequestDto: UpdateWorkflowConfigurationRequestDto, ): Promise<WorkflowConfigurationsControllerCreate200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling workflowConfigurationsControllerUpdate.');
    }
    if (updateWorkflowConfigurationRequestDto === null || updateWorkflowConfigurationRequestDto === undefined) {
      throw new Error('Required parameter updateWorkflowConfigurationRequestDto was null or undefined when calling workflowConfigurationsControllerUpdate.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.put({
      url: `${this.configuration.basePath}/api/forthbridge-workflow-session/workflow-configurations/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
        data: updateWorkflowConfigurationRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
